import { render, staticRenderFns } from "./add_Douyin.vue?vue&type=template&id=5eca8476&scoped=true"
import script from "./add_Douyin.vue?vue&type=script&lang=js"
export * from "./add_Douyin.vue?vue&type=script&lang=js"
import style0 from "./add_Douyin.vue?vue&type=style&index=0&id=5eca8476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eca8476",
  null
  
)

export default component.exports